<div
    bsModal
    #createOrEditModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createOrEditModal"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #accountSubGroupForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span *ngIf="accountSubGroup.id">{{ l('EditAccountSubGroup') }}</span>

                        <span *ngIf="!accountSubGroup.id">{{ l('CreateNewAccountSubGroup') }}</span>
                    </h4>

                    <button
                        type="button"
                        class="btn-close"
                        (click)="close()"
                        aria-label="Close"
                        [disabled]="saving"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="my-3">
                        <label class="form-label" for="AccountSubGroup_Code">{{ l('Code') }} *</label>
                        <input
                            type="text"
                            #AccountSubGroup_Code="ngModel"
                            id="AccountSubGroup_Code"
                            class="form-control"
                            [(ngModel)]="accountSubGroup.code"
                            name="Code"
                            minlength="0"
                            maxlength="50"
                            required
                        />
                        <validation-messages [formCtrl]="AccountSubGroup_Code"></validation-messages>
                    </div>

                    <div class="my-3">
                        <label class="form-label" for="AccountSubGroup_Name">{{ l('Name') }} *</label>
                        <input
                            type="text"
                            #AccountSubGroup_Name="ngModel"
                            id="AccountSubGroup_Name"
                            class="form-control"
                            [(ngModel)]="accountSubGroup.name"
                            name="Name"
                            minlength="0"
                            maxlength="500"
                            required
                        />
                        <validation-messages [formCtrl]="AccountSubGroup_Name"></validation-messages>
                    </div>
                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-default" (click)="close()">
                        {{ l('Cancel') }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-primary blue"
                        [disabled]="!accountSubGroupForm.form.valid"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
